// extracted by mini-css-extract-plugin
export default {"termsWrapper":"LegalText_termsWrapper__MQOAf","terms":"LegalText_terms__G-gNU"};